export default __webpack_public_path__ + "static/media/acceleZ.e766a361.svg";